import { useEffect, useState } from 'react';
import { DocumentNode } from '@apollo/client';
import { ClientType } from './types';
import getApolloClient, {
  AUTHORING_AGGREGATOR_ENDPOINT,
  MARKETPLACE_GATEWAY,
  ORGANISATION_SERVICE_ENDPOINT,
  TENANT_GATEWAY_ENDPOINT,
} from '../getApolloClient';

type Props = {
  variables?: any;
  query: DocumentNode;
  client?: ClientType;
  responseField: string;
  refetchByChange?: any;
};

const useQuery = <TData = any, TResponse = any>({
  variables = {},
  query,
  client = ClientType.ORGANISATION_SERVICE,
  responseField,
  refetchByChange = '',
}: Props) => {
  const getClient = () => {
    return getApolloClient(
      {
        [ClientType.AUTHORING_AGGREGATOR]: AUTHORING_AGGREGATOR_ENDPOINT,
        [ClientType.ORGANISATION_SERVICE]: ORGANISATION_SERVICE_ENDPOINT,
        [ClientType.GRAPHQL_GATEWAY]: TENANT_GATEWAY_ENDPOINT,
        [ClientType.MARKETPLACE]: MARKETPLACE_GATEWAY,
      }[client],
    );
  };

  const [data, setData] = useState<TData>();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const { data } = await getClient().query<TResponse>({
        query,
        variables,
      });

      const res = (data as any)[responseField];

      if (res) {
        setData(res as TData);
      }
    } catch (e: any) {
      setError(e);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [refetchByChange]);

  return {
    data,
    isLoading,
    error,
    refetch: fetchData,
  };
};

export default useQuery;
